import { AsyncReturnType } from "type-fest";

import { ConversationService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<
  typeof ConversationService.cancelScheduledMessage
>[0];
type Data = AsyncReturnType<typeof ConversationService.cancelScheduledMessage>;
type Error = unknown;

export const useCancelScheduledMessage = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    ConversationService.cancelScheduledMessage,
    options
  );

  return result;
};
